/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Weak_Rust_Dog_JumpInputs */

const en_weak_rust_dog_jump = /** @type {(inputs: Weak_Rust_Dog_JumpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show`)
};

const de_weak_rust_dog_jump = /** @type {(inputs: Weak_Rust_Dog_JumpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzeigen`)
};

/**
* | output |
* | --- |
* | "Show" |
*
* @param {Weak_Rust_Dog_JumpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const weak_rust_dog_jump = /** @type {((inputs?: Weak_Rust_Dog_JumpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Weak_Rust_Dog_JumpInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_weak_rust_dog_jump(inputs)
	return de_weak_rust_dog_jump(inputs)
});